import React from 'react';
import { useProductsWrapperInfinite } from 'modules/page-builder/hooks/usePbProducts';
import { ProductGridProps, Spinner } from './ProductGridDesktopSlot';
import { ProductGrid } from '@teko/teko-ecommerce';
import { useTenantConfig } from 'hooks';
import { t } from 'i18n';
import { Flex, Button, Shape } from '@teko/ds-mobile';
import { LazyComponent } from 'components/LazyComponent';

export const ProductGridMobileSlot: React.FC<ProductGridProps> = ({
  collectionSlug,
  serverData,
}: ProductGridProps) => {
  const { contactLink } = useTenantConfig();

  const [{ products, hasMore, loading }, { onNextPage }] =
    useProductsWrapperInfinite(collectionSlug ?? '', {
      initialValue: serverData,
      limit: 20,
    });

  return products ? (
    <Flex direction="column" backgroundColor="#f6f6f6" justify="center">
      <ProductGrid
        products={products}
        regionName="forYouListProduct"
        contactLink={contactLink}
        productsPerRow={2}
      />
      {hasMore && (
        <Shape
          width={'100%'}
          paddingLeft="s8"
          paddingRight="s8"
          marginTop="s16"
          marginBottom="s4"
        >
          <Button
            backgroundColor="#fff"
            block
            onClick={onNextPage}
            variant="white-ghost"
            color="#000000"
            disabled={loading}
          >
            {loading && <Spinner />}
            {t('Xem thêm')}
          </Button>
        </Shape>
      )}
    </Flex>
  ) : null;
};

export const LazyProductGridMobileSlot: React.FC<ProductGridProps> = (
  props,
) => {
  return (
    <LazyComponent>
      <ProductGridMobileSlot {...props} />
    </LazyComponent>
  );
};
